import { render } from "./dashBoardPagination.vue?vue&type=template&id=010d3754&scoped=true&ts=true"
import script from "./dashBoardPagination.vue?vue&type=script&lang=ts"
export * from "./dashBoardPagination.vue?vue&type=script&lang=ts"

import "./dashBoardPagination.vue?vue&type=style&index=0&id=010d3754&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010d3754"]])

export default __exports__